/**
 * Generate overlapping CSS mask gradients for a "progressive blur" effect.
 * Later segments automatically get wider & shifted masks so the blurred
 * layers blend smoothly with no gaps.
 */
export function generateProgressiveMasks(segments: number): string[] {
  if (segments <= 0) return [];

  const masks: string[] = [];
  const baseStart = 5;
  const baseOpaque = 20;
  const baseFade = 10;

  for (let i = 0; i < segments; i++) {
    const growth = 1 + i * 0.2;
    const fadeWidth = baseFade * growth;
    const opaqueWidth = baseOpaque * growth;
    const start = baseStart + i * 10;

    const a = Math.max(0, start - fadeWidth / 2);
    const b = Math.max(0, start);
    const c = Math.min(100, start + opaqueWidth);
    const d = Math.min(100, c + fadeWidth / 2);

    const mask = `linear-gradient(
      rgba(0, 0, 0, 0) ${a}%,
      rgba(0, 0, 0, 1) ${b}%,
      rgba(0, 0, 0, 1) ${c}%,
      rgba(0, 0, 0, 0) ${d}%
    )`;

    masks.push(mask.replace(/\s+/g, ' '));
  }

  return masks;
}
